import apiFetch from '@wordpress/api-fetch'

import { getBootstrap } from './index'

let configured = false

const normalizeRestBase = (restBase: string): string => {
  if (!restBase) {
    return restBase
  }

  if (!restBase.endsWith('/')) {
    return `${restBase}/`
  }

  return restBase
}

export const getConfiguredApiFetch = () => {
  if (!configured) {
    const { restBase, nonce } = getBootstrap()

    const normalizedRestBase = normalizeRestBase(restBase)

    apiFetch.use(apiFetch.createRootURLMiddleware(normalizedRestBase))

    if (nonce) {
      apiFetch.use(apiFetch.createNonceMiddleware(nonce))
    }

    configured = true
  }

  return apiFetch
}

export type ConfiguredApiFetch = ReturnType<typeof getConfiguredApiFetch>
